import { useGetTjenesteTeksterQuery } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { useAppSelector } from '../../store/hooks';
/**
 * Hent feedbacktekter for en tjeneste
 * @param tjenesteNavn Navn på tjenesten
 */
const useFeedbackResources = (tjenesteNavn) => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data, isLoading, isError } = useGetTjenesteTeksterQuery({
        navn: tjenesteNavn,
        languageCode: language,
    });
    return {
        feedback: data?.feedback,
        isLoading,
        isError,
    };
};
export default useFeedbackResources;
